<script setup lang="ts">
import { type FieldContext, useField } from 'vee-validate'

defineSlots<{
  default: (scope: FieldContext) => Any
}>()

const props = defineProps<{
  name: string
}>()

const field = useField(() => props.name)
</script>

<template>
  <section class="field-item">
    <slot v-bind="field" />
  </section>
</template>
